import type { MailboxInfo, MailboxType } from 'owa-client-types';
import type { AccountState } from 'owa-account-source-list-store';

/**
 * To support multiple platform we need to be able to abstract the underlying source, whether it is
 * a OWS accessed mailbox or HxAccount, from the code above the GraphQL resolvers. For this purpose
 * account data is represented as a sourceId and a displayName.
 */
export interface SourceIdAndDisplayName {
    id: string;
    displayName: string;
}

// Defines the type uses to store information for hte source list
export interface LegacySourceInformation extends SourceIdAndDisplayName {
    stableId: string;
    properties: Map<string, string>;
    mailboxInfo?: MailboxInfo;
    mailboxType?: string;
}

export interface SourceCharacteristics {
    supportsCalendar: boolean;
    supportsContacts: boolean;
    supportsMail: boolean;
    supportsSettings: boolean;
}

export interface SourceMailbox {
    type: MailboxType;
    name: string;
    displayName: string;
    emailAddress: string;
    loginAddress: string;
    userIdentity: string;
    routingHint: string;
    alternateId: string;
    accountUniqueId: string;
    imageUrl: string;
    profileUrl: string;
}

export enum SourceType {
    Mailbox = 'MAILBOX',
}

export enum SourceAuthType {
    Microsoft365 = 'MICROSOFT365',
    OutlookDotCom = 'OUTLOOKDOTCOM',
}

export interface HostSourceInformation {
    sourceType: SourceType;
    authProviderType: SourceAuthType;
    displayName: string;
    characteristics: SourceCharacteristics;
    mailbox?: SourceMailbox;
    accountState?: AccountState;
}

export interface SourceInformation extends HostSourceInformation {
    sourceId: string;
}

export enum CreateAccountErrors {
    GetAuthTokenFailed = 'INVALIDCREDENTIALS',
    CouldNotConnect = 'CONNECTFAILED',
    DuplicateAccount = 'DUPLICATE',
    ProviderNotSupported = 'NOTSUPPORTED',
}

/**
 * Defines the result that will be returned by create accounts calls
 */
export interface CreateAccountResult {
    wasSuccessful: boolean;
    error?: CreateAccountErrors;
    sourceId?: string;
}

export enum RemoveAccountErrors {
    AccountNotFound = 'NOT_FOUND',
}

/**
 * Defines the result that will be returned by remove accounts calls
 */
export interface RemoveAccountResult {
    wasSuccessful: boolean;
    error?: RemoveAccountErrors;
}
